import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';
import { BrandTitle } from '../styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  padding: 0;
  user-select: none;

  &:before {
    content: "";
    display: block;
    order: -1;
    height: 0px;
    margin: 0 40px 16px 40px;
    border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  }
`;

const Title = styled(BrandTitle)`
  margin: 0 48px;
`;

const Paragraph = styled.p`
  margin: 5px 48px 23px 48px;
  font: ${props => props.theme.fontWeightMedium} 12px/120% ${props => props.theme.fontFamilyBody};
`;

const Peek = styled.div`
  width: 642px;
  height: 57px;
  background-color: ${props => props.bgColor};
  border: 1px solid ${props => props.borderColor};
  border-radius: 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
  align-items: center;

  & > img {
    object-fit: contain;
    max-height: 24px;
    max-width: 79px;
  }
`;

const Placeholder = styled.span`
  display: inline-block;
  width: 79px;
  height: 24px;
  background-color: ${props => props.theme.secondaryColorLight};
`;

const white = '#ffffff';
export default function Preview({ logo, color }) {
  let c;
  try {
    c = Colour(color || white);
  } catch (err) {
    c = Colour(white);
  }
  const peekProps = {
    bgColor: c.rgb().toString(),
    borderColor: c.alpha() === 0 || c.white() === 100 ? '#e9eef3' : c.rgb().toString(),
  };

  return (
    <Container>
      <Title>Brand Preview</Title>
      <Paragraph>
        Below is a preview of your brands appearance on the profiles, and micro
        profiles, of all contributors in your company.
      </Paragraph>
      <Peek {...peekProps}>
        {logo ? <img src={logo} alt="logo" /> : <Placeholder />}
      </Peek>
    </Container>
  );
}

Preview.propTypes = {
  logo: PropTypes.string,
  color: PropTypes.string,
};

Preview.defaultProps = {
  logo: null,
  color: null,
};
